import * as React from "react";
import { connect } from "react-redux";

import { Divider } from "@mui/material";

import { AdminStatistics, AdminUserStatistics } from "../models";
import { loadStatistics } from "../actions";
import { ApplicationState } from "../../applicationState";

import { AdminStatisticsGrid } from "./AdminStatisticsGrid";
import { AdminUserStatisticsGrid } from "./AdminUserStatisticsGrid";

interface StateProps {
    adminStatistics: AdminStatistics;
    adminUserStatistics: AdminUserStatistics;
    userId?: string;
}

interface DispatchProps {
    loadAdminStatistics: () => void;
}

const StatisticsGridAndLoaderNewUnconnected: React.FunctionComponent<StateProps & DispatchProps> = (props: StateProps & DispatchProps) => {
    const { loadAdminStatistics } = props;

    React.useEffect(() => {
        if (loadAdminStatistics) {
            loadAdminStatistics();
        }
    }, [loadAdminStatistics]);

    return (
        <>
            <AdminUserStatisticsGrid statistics={props.adminUserStatistics} userId={props.userId} />
            <Divider />
            <AdminStatisticsGrid statistics={props.adminStatistics} />
            <Divider />
        </>);
};

function mapStateToProps(state: ApplicationState): StateProps {
    return {
        adminStatistics: state.statistics.adminStatistics,
        adminUserStatistics: state.statistics.adminUserStatistics,
        userId: state.currentUser.id
    };
}

function mapDispatchToProps(dispatch: any): DispatchProps {
    return {
        loadAdminStatistics: () => dispatch(loadStatistics()),
    };
}

export const StatisticsGridAndLoaderNew = connect(mapStateToProps, mapDispatchToProps)(StatisticsGridAndLoaderNewUnconnected);
